<div class="language-switch">
    <div class="item" *ngFor="let lang of languages" [class.active]="selected === lang.code">
      <a (click)="switchLang(lang.code)">
        <span [className]="'flag flag-xs flag-' + lang.flag"></span>
      </a>
    </div>
</div>
